var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-btn',{attrs:{"text":_vm.locale},nativeOn:{"click":function($event){return _vm.changeLocale.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }